export default __webpack_public_path__ + "static/media/crop-icon.5408567e.png";